<template>
  <widget-upload
    :multiple="maxFilesCount > 1"
    :accept="accept"
    @files-picked="$emit('files-picked', $event)"
  >
    <template v-slot="{ browseFile }">
      <div
        class="file-drop-zone"
        :class="{ 'file-drop-zone--drag-over': isDragOver }"
        v-bind="dropZoneProps"
      >
        <widget-button
          class="w100pr"
          color="blue"
          view="transparent"
          @click="browseFile"
        >
          <div class="d-flex align-center gap-2">
            <widget-icon
              name="add"
              size="20px"
              class="blue--text"
            />
            {{ $t('messengerWidget.attachmentsField.addFiles', { count: maxFilesCount }) }}
          </div>
        </widget-button>
      </div>
    </template>
  </widget-upload>
</template>

<script lang="ts" setup>
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'
import WidgetUpload from '@widgets/shared/components/WidgetUpload.vue'
import WidgetButton from '@widgets/shared/components/WidgetButton.vue'
import { useDragAndDropFiles } from '@widgets/messenger/compositions/useDragAndDropFiles'

defineProps<{
  accept: string[]
  maxFilesCount: number
}>()

const emit = defineEmits<{
  (e: 'files-picked', files: File[]): void
}>()

const { dropZoneProps, isDragOver } = useDragAndDropFiles((files) => {
  emit('files-picked', files)
})
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.file-drop-zone {
  border-radius: $border-radius-x;
  // https://kovart.github.io/dashed-border-generator/
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='%23D0D5DDFF' stroke-width='2' stroke-dasharray='4%2c 10' stroke-dashoffset='17' stroke-linecap='square'/%3e%3c/svg%3e");

  &--drag-over {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='%230080EAFF' stroke-width='2' stroke-dasharray='4%2c 10' stroke-dashoffset='17' stroke-linecap='square'/%3e%3c/svg%3e");
  }
}
</style>
